export const ru = {
  main: 'Главная',
  journal: 'Журнал',
  moreButtonTitle: 'ещё',
};

export default ru;
